import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import MainPage from './pages/MainPage/MainPage';
import Signup from './components/Signup/Signup';
import Login from './components/Login/Login';
import StrategyHistory from './pages/StrategyHistory/StrategyHistory';
import Backtests from './pages/Backtests/Backtests';
import StartPage from './pages/StartPage';
import { useEffect } from "react";

function App() {

    useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      localStorage.setItem("token", token);
      window.history.replaceState({}, document.title, window.location.pathname);
      window.location.reload();
    }
  }, []);

  const user = localStorage.getItem("token")
  return (
    <Router>
      <div className="App">
        <Routes>
          {user && <Route path="/" element={<MainPage />} />}
          {!user && <Route path="/login" element={<Login />} />}
          <Route path="/signup" element={<Signup />} />
          {user && <Route path="/history" element={<StrategyHistory />} />}
          {user && <Route path="/backtests" element={<Backtests />} />}
          {!user && <Route path="/" element={<StartPage />} />}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
